import { render } from "./Syssetting.vue?vue&type=template&id=7aa289a0&scoped=true&ts=true"
import script from "./Syssetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./Syssetting.vue?vue&type=script&setup=true&lang=ts"

import "./Syssetting.vue?vue&type=style&index=0&id=7aa289a0&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa289a0"],['__file',"src/views/me/Syssetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7aa289a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7aa289a0', __exports__)) {
    console.log('reload')
    api.reload('7aa289a0', __exports__)
  }
  
  module.hot.accept("./Syssetting.vue?vue&type=template&id=7aa289a0&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('7aa289a0', render)
  })

}


export default __exports__